// import { createSlice } from '../../utils/npm'

// let initialState = {
//     isloading: false,
// }

// const masterSlice = createSlice({
//     name: 'masterslice',
//     initialState: initialState,
//     reducers: {
//         startMasterLoding(initialState, action) {
//             initialState.isloading = action?.payload
//         },
//         stopMasterLoding(initialState, action) {
//             initialState.isloading = action?.payload
//         },
//     },
// });

// export const { startMasterLoding, stopMasterLoding } = masterSlice.actions;
// export default masterSlice.reducer;
// slidebarData

import { createAsyncThunk } from '@reduxjs/toolkit';
import { createSlice } from '../../utils/npm'

// export const getSlidebarDataListThunk = createAsyncThunk("slidebarDataList", async (submitData, { dispatch }) => {
//     try {
//         // dispatch(setLoader(true))
//         const { data: subAdmin } = await API.slidebarData(submitData);
//         // dispatch(setLoader(false))
//         return subAdmin;
//     } catch (error) {
//         throw error;
//     }
// });

let initialState = {
    isloading: false,
    ipoHomePageList: [],
    filterGlobal: "",
    headerLoad: false,
    fooerLoad: false,
    searchIPO: "",
   homepageBanner : {}
}

const masterSlice = createSlice({
    name: 'masterslice',
    initialState: initialState,
    reducers: {
        startMasterLoding(initialState, action) {
            initialState.isloading = action?.payload
        },
        stopMasterLoding(initialState, action) {
            initialState.isloading = action?.payload
        },
        setIpoHomePageLIstData(initialState, action) {
            initialState.ipoHomePageList = action?.payload
        },
        setFilterGlobal(initialState, action) {
            initialState.filterGlobal = action?.payload
        },
        setHeaderLoad(initialState, action) {
            initialState.headerLoad = action?.payload
        },
        setFooterLoad(initialState, action) {
            initialState.fooerLoad = action?.payload
        },
        setSearchIPO(initialState, action) {
            initialState.searchIPO = action?.payload
        },
        setHomePageBanner(initialState, action) {
            initialState.homepageBanner = action?.payload
        }
    },
});

export const { startMasterLoding, stopMasterLoding, setIpoHomePageLIstData, setFilterGlobal, setHeaderLoad, setFooterLoad, setSearchIPO , setHomePageBanner} = masterSlice.actions;
export default masterSlice.reducer;